import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';
import { PaymentDashboard } from '../../../payments/PaymentDashboard';
import { PaymentSummary } from '../../../payments/PaymentSummary';

export default function PaymentsRoutes() {
    return (
        <>
            <Route
                path='/payment/dashboard'
                element={
                    <RequireAdmin>
                        <PaymentDashboard />
                    </RequireAdmin>
                }
            />
            <Route
                path='/payment/information'
                element={
                    <RequireAdmin>
                        <PaymentSummary />
                    </RequireAdmin>
                }
            />
        </>
    );
}
